
















import { Prop, Component, Vue } from 'vue-property-decorator';
// import { Editor, EditorContent } from 'tiptap';
import javascript from 'highlight.js/lib/languages/javascript';
import css from 'highlight.js/lib/languages/css';
import python from 'highlight.js/lib/languages/python';
import typescript from 'highlight.js/lib/languages/typescript';
import json from 'highlight.js/lib/languages/json';
import yaml from 'highlight.js/lib/languages/yaml';
import java from 'highlight.js/lib/languages/java';
import _ from 'lodash';

import { convertHTMLToMarkdown, convertMarkdownToHTML, globalState } from '@/shared';

import { Code } from '../tiptap-extensions/marks/Code';

import { CodeBlock, CodeBlockHighlight, OrderedList } from 'tiptap-extensions';

import {
  // necessary extensions
  Doc,
  Text,
  Paragraph,
  Heading,
  Bold,
  Underline,
  HardBreak,
  Italic,
  Strike,
  ListItem,
  BulletList,
  Link,
  // OrdererList,
  Blockquote,
  Image,
  // Code,
  // CodeBlock,
  HorizontalRule,
  History,
} from 'element-tiptap';
import { MenuData } from 'tiptap';

export type IOutline = {
  text: string;
  level: number;
};

@Component({
  components: {},
})
export default class TextArea extends Vue {
  @Prop() text!: string;
  globalState = globalState;
  extensions = [
    new Doc(),
    new Text(),
    new Paragraph(),
    new Heading(),
    new Bold(),
    new Underline(),
    new Italic(),
    new HardBreak(),
    new Strike(),
    new ListItem(),
    new Link(),
    new OrderedList(),
    new BulletList(),
    new Blockquote(),
    new Image(),
    new Code(),
    new CodeBlock(),
    new CodeBlockHighlight({
      languages: {
        javascript,
        css,
        python,
        typescript,
        json,
        yaml,
        java,
      },
    }),
    new HorizontalRule(),
    new History(),
  ];

  onTipTapInit({ editor }: MenuData) {
    this.globalState.editor = editor;
    this.updateGlobalState(convertMarkdownToHTML(this.text));
  }

  onTipTapUpdate(html: string) {
    // console.time('Update');
    this.updateGlobalState(html);
    this.updateStorage(html);
    // console.timeEnd('Update');
  }

  updateGlobalState(html: string) {
    this.globalState.editorContentHtml = html;
    this.globalState.isEmpty = this.globalState.editorContentHtml.length < 8;
  }

  updateStorage = _.debounce((html: string) => {
    localStorage.editorContentHtml = convertHTMLToMarkdown(html);
  }, 1000);

  beforeMount() {
    // console.log(this.editor);
  }

  beforeUnmount() {
    // this.editor.destroy();
  }
}
